/**
 * Auto Error Encountered — 에러 캡처
 * unhandledrejection → API 에러 (axios reject 등)
 * error → JS 에러
 * 절대 에러를 swallow하지 않음 — 관찰만 하고 원래 에러 흐름은 유지
 */

import { truncate } from "./utils";

var MAX_MSG_LEN = 200;

function extractErrorMessage(error) {
  try {
    if (!error) return "Unknown error";
    if (typeof error === "string") return truncate(error, MAX_MSG_LEN);
    if (error.message) return truncate(error.message, MAX_MSG_LEN);
    if (error.response && error.response.status) {
      return truncate(
        "HTTP " + error.response.status + " " + (error.response.statusText || ""),
        MAX_MSG_LEN,
      );
    }
    return truncate(String(error), MAX_MSG_LEN);
  } catch (e) {
    return "Error extraction failed";
  }
}

export function initErrorTracking(mixpanel) {
  // Unhandled Promise Rejection (주로 API 에러)
  window.addEventListener("unhandledrejection", function (event) {
    try {
      var reason = event.reason;
      var isApiError = false;
      var errorMessage = "";

      // axios 에러 판별
      if (reason && reason.isAxiosError) {
        isApiError = true;
        errorMessage = extractErrorMessage(reason);
      } else if (reason && reason.response && reason.response.status) {
        isApiError = true;
        errorMessage = extractErrorMessage(reason);
      } else {
        errorMessage = extractErrorMessage(reason);
      }

      var trackFn = function () {
        try {
          mixpanel.track("Auto Error Encountered", {
            error_type: isApiError ? "api" : "js",
            error_message: errorMessage,
            route_path: window.location.pathname,
          });
        } catch (e) {
          // 무시
        }
      };

      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(trackFn);
      } else {
        setTimeout(trackFn, 0);
      }
    } catch (e) {
      // 트래킹 실패 — 원래 에러 흐름은 유지됨 (event.preventDefault() 호출 안 함)
    }
    // 의도적으로 event.preventDefault() 호출하지 않음 — 원래 에러 흐름 유지
  });

  // JS 에러
  window.addEventListener("error", function (event) {
    try {
      var errorMessage = "";
      if (event.error) {
        errorMessage = extractErrorMessage(event.error);
      } else if (event.message) {
        errorMessage = truncate(event.message, MAX_MSG_LEN);
      } else {
        errorMessage = "Unknown JS error";
      }

      var trackFn = function () {
        try {
          mixpanel.track("Auto Error Encountered", {
            error_type: "js",
            error_message: errorMessage,
            error_source: truncate(event.filename || "", MAX_MSG_LEN),
            error_line: event.lineno || 0,
            route_path: window.location.pathname,
          });
        } catch (e) {
          // 무시
        }
      };

      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(trackFn);
      } else {
        setTimeout(trackFn, 0);
      }
    } catch (e) {
      // 트래킹 실패 — 원래 에러 흐름 유지
    }
    // 의도적으로 return 하지 않음 — 원래 에러 핸들러 체인 유지
  });
}
